// =====================================================
// CORE BUNDLE ENTRY POINT (fredline-core.js)
// Full comparison engine + DOCX generation + move detection for all tiers.
// Free tier: 5-page limit, watermark, no PDF, no track changes.
// Pro adds: PDF parsing, track changes, no watermark.
// =====================================================

// Re-export everything the app needs from the core engine
export { parseDocument, textToParagraphs, extractRichParagraphs, tokenizeToRich } from './parsers-core';
export { diffDocuments, matchParagraphs, diffArrays, tokenize, normalizeText, normalizeQuotes, wordsEqual, similarity, cheapSimilarity } from './diff-engine-core';
export { countWords } from './counts';
export { renderRedline, renderParagraph, renderDiffInline, escapeHtml } from './renderer';
export { createState } from './state';
export type { FredlineState } from './state';
export { W_NS, serializeNode, getInnerXml, xmlEscape } from './xml-helpers';

// DOCX generator (shared by free + pro — free adds watermark)
export { generateRedlineDocx, diffAncillaryContent, recordChanges } from './docx-generator';
// What the writer recorded of the changes it wrote (the change list reads it)
export { changeRecordOf } from './change-record';
export type { ChangeRecord, RecordedChange } from './change-record';

// The comparison summary (the .docx's last page; the first page of a PDF export)
export { buildSummaryModel, summaryHtml, SUMMARY_CSS } from './summary';

// Bridge exports (pro bundle registration + feature checks)
export { isProActive, activatePro, getPdfParser } from '../bridge';

// Re-export types
export type { RichParagraph, ParsedDocument, DiffResult, DiffEntry, DiffParagraph, DiffStats, RichToken, CellData, CellInfo, PdfParserFn, MoveDetectorFn, DocxGeneratorFn } from '../types';
